import { render, staticRenderFns } from "./AppCustomShortcutsForm.vue?vue&type=template&id=654334ee"
import script from "./AppCustomShortcutsForm.vue?vue&type=script&lang=js"
export * from "./AppCustomShortcutsForm.vue?vue&type=script&lang=js"
import style0 from "./AppCustomShortcutsForm.vue?vue&type=style&index=0&id=654334ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports